import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from "react-cookie";

import "./index.scss";

import { lang } from "./i18n";
import LoadingIndicator from "./components/loading-indicator/loading-indicator";

import App from "./App";

ReactDOM.render(
  <BrowserRouter basename={"/sa/" + lang + "/booking/"}>
    <CookiesProvider>
      <App />
    </CookiesProvider>
    <LoadingIndicator />
  </BrowserRouter>,
  document.getElementById("root")
);
